import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import CartContext from "../../context/cart";
import UserContext from "../../context/user";
import { computePartial } from "../../utils/partial";

export const updateCartRequest = (
  {
    campaignId,
    cartRequest,
    survey,
    email,
    phone,
    deliveryInformation,
    formData,
    values,
    partial,
    clearReservation = false,
    confirmationStep = false,
    status,
    pickupPointId,
  },
  callApi
) => {
  const surveryAnswer = computePartial(survey, { ...formData, ...values }, partial, status);

  return callApi(`/cart/request/update/${campaignId}/${cartRequest.id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: cartRequest.id,
      contentId: cartRequest.contentId,
      surveyAnswer: surveryAnswer,
      ...(email ? { welfareEmail: email } : {}),
      ...(phone ? { welfarePhone: phone } : {}),
      ...(clearReservation ? { clearReservation: true } : {}),
      ...(confirmationStep ? { confirmationStep: true } : {}),
      ...(deliveryInformation
        ? {
            deliveryInformation: {
              destinatario: deliveryInformation.destinatario,
              indirizzo: deliveryInformation.indirizzo,
              numeroCivico: deliveryInformation.numeroCivico,
              cap: deliveryInformation.cap,
              city: deliveryInformation.city,
              provincia: deliveryInformation.provincia,
            },
          }
        : {}),
      ...(pickupPointId
        ? {
            pickupPointId: pickupPointId,
          }
        : {}),
    }),
  });
};

const useCartRequestUpdateMutation = () => {
  const { callApi } = useContext(UserContext);
  const { setCartRequest, handleNext, setFormData } = useContext(CartContext);

  return useMutation(
    ({
      campaignId,
      cartRequest,
      survey,
      email,
      phone,
      deliveryInformation,
      formData,
      values,
      partial,
      clearReservation = false,
      confirmationStep = false,
      status,
    }) =>
      updateCartRequest(
        {
          campaignId,
          cartRequest,
          survey,
          email,
          phone,
          deliveryInformation,
          formData,
          values,
          partial,
          clearReservation,
          confirmationStep,
          status,
        },
        callApi
      ),
    {
      onSuccess: (data, variables) => {
        setCartRequest(data);
        if (data?.surveySubmission?.submissionId) {
          handleNext(data.surveySubmission.submissionId);
          setFormData((current) => ({ ...current, ...variables.values }));
        }
      },
    }
  );
};

export default useCartRequestUpdateMutation;
